import {
  LoadingContainer,
  LegacyPage,
  Model,
  Panels,
  Bar,
  Modal,
} from 'peach/components'
import { Switch, Route, Redirect, useParams, useRouteMatch } from 'peach/router'

import {
  useLoanTypeDynamicFeeGetAll,
  useLoanTypeDynamicFeeTypeAdd,
} from 'core/types'

import CreateDynamicFeeTypeForm from './CreateDynamicFeeTypeForm'
import DynamicFeeType from './DynamicFeeType'

const DynamicFeeTypes = () => {
  const { path, url } = useRouteMatch()
  const { companyId, loanTypeId } = useParams<{
    companyId?: string
    loanTypeId?: string
  }>()

  const { data: dynamicFeeTypes, isLoading } = useLoanTypeDynamicFeeGetAll({
    companyId,
    loanTypeId,
  })

  const { mutateAsync: createDynamicFeeType } = useLoanTypeDynamicFeeTypeAdd({
    companyId,
    loanTypeId,
  })

  const createDynamicFeeTypeModal = (
    <Modal
      initialValue={{ feeType: 'modificationFee' }}
      onSubmit={async (value) => await createDynamicFeeType(value)}
      pages
      title='Create Dynamic Fee Type'
      trigger
    >
      <CreateDynamicFeeTypeForm />
    </Modal>
  )

  const header = (
    <Bar right={createDynamicFeeTypeModal} title='Dynamic Fee Types' />
  )

  return (
    <LoadingContainer isLoading={isLoading}>
      <Switch>
        <Route exact path={path}>
          <Panels header={header}>
            <LegacyPage.Full>
              <Model.List json={dynamicFeeTypes} title='Dynamic Fee Types' />
            </LegacyPage.Full>
          </Panels>
        </Route>
        <Route path={`${path}/:dynamicFeeTypeId`}>
          <DynamicFeeType />
        </Route>
        <Redirect to={url} />
      </Switch>
    </LoadingContainer>
  )
}

export default DynamicFeeTypes
